import { Component, computed, input } from '@angular/core';
import {
  ConditionOption,
  ListingItemModel,
} from '../../../../domain/models/listing.model';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ListingDataviewComponent } from '../../../shared/components/listing-dataview/listing-dataview.component';
import { Skeleton } from 'primeng/skeleton';
import { listingConditionOptions } from '../../../shared/constants/listing-condition-options';

@Component({
  selector: 'otw-listings',
  standalone: true,
  imports: [RouterLink, CommonModule, ListingDataviewComponent, Skeleton],
  templateUrl: './listings.component.html',
  styles: ``,
})
export class ListingsComponent {
  constructor() {}

  isLoading = input<boolean>(false);
  listings = input<ListingItemModel[]>([]);

  getConditionLabel(conditionValue: ConditionOption) {
    const conditionOption = listingConditionOptions.find(
      (condition) => condition.value === conditionValue
    );

    if (!conditionOption) return;

    return conditionOption.label;
  }

  getImageUrls(listing: ListingItemModel): string[] {
    if (!listing.images) return [];
    return listing.images.map((m) => m.thumbnail_url || m.url);
  }
  setDefaultImg(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/no-img.jpg';
  }
}
